<template>
	<section class="form form__vertical" :class="{ container__booking: !modal }">
		<div class="form__heading">
			<h1 class="heading-title">{{ $t('auth.login') }}</h1>
			<h2 class="content-default">
				{{ $t('auth.not_account') }} <a class="link" @click="registerForm">{{ $t('auth.to_register') }}</a>
			</h2>
		</div>
		<form class="form__input flex-vertical left-align" @submit.prevent="validateForm" @keydown="form.onKeydown($event)">
			<label for="email" class="label left-align">
				<b>{{ $t('fields.email') }}</b>
			</label>

			<input
				name="email"
				type="text"
				v-model="form.email"
				class="input"
				:class="{ 'is-danger': form.errors.has('email') }"
				:placeholder="$t('auth.your_email')"
			/>

			<label for="password" class="label left-align">
				<b>{{ $t('fields.password') }}</b>
			</label>

			<input
				name="password"
				type="password"
				v-model="form.password"
				class="input"
				:class="{ 'is-danger': form.errors.has('password') }"
				:placeholder="$t('fields.password')"
			/>

			<div class="checkbox-section centered spacer_bottom-125">
				<div class="b-row b__control-row flex-horizontal">
					<label class="b__control-line flex-horizontal">
						<input type="checkbox" v-model="remember" class="b__control-input" />
						<span class="b__control-checkbox"></span>
						<span class="b__control-label booking-regular">{{ $t('auth.remember_me') }}</span>
					</label>
				</div>
			</div>

			<v-button class="spacer_bottom-125" :loading="form.busy">{{ $t('auth.login') }}</v-button>

			<span class="content-default spacer_blank centered">
				<router-link :to="{ name: 'password.request' }" class="link">{{ $t('auth.forgotten_password') }}</router-link>
			</span>
		</form>
	</section>
</template>

<script>
import Form from 'vForm'
import loginMixin from '~/mixins/login.mixin.js'

export default {
	name: 'Login',
	middleware: 'guest',

	mixins: [loginMixin],

	props: {
		modal: {
			type: Boolean,
			default: false,
		},
	},

	metaInfo() {
		return { title: this.$t('auth.login') }
	},

	data: () => ({
		form: new Form({
			email: null,
			password: null,
		}),
		remember: false,
	}),

	watch: {
		$route() {
			this.$emit('close')
		},
	},

	methods: {
		registerForm() {
			this.$emit('close')
			setTimeout(() => {
				this.$modal('auth/register')
			}, 300)
		},
		async validateForm() {
			await this.form.clear()
			let { email, password } = this.form
			if (!email) this.form.errors.set('email', this.$t('validation.field_is_required', [this.$t('fields.email')]))
			if (!password) this.form.errors.set('password', this.$t('validation.field_is_required', [this.$t('fields.password')]))

			if (!this.form.errors.any()) await this.login(this.remember, this.modal)
			else this.$notifyAllErrors(this.form.errors.all())
		},
	},
}
</script>
